var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.583 4.49967H19.1663V6.33301H17.333V18.2497C17.333 18.4928 17.2364 18.7259 17.0645 18.8979C16.8926 19.0698 16.6595 19.1663 16.4163 19.1663H3.58301C3.33989 19.1663 3.10673 19.0698 2.93483 18.8979C2.76292 18.7259 2.66634 18.4928 2.66634 18.2497V6.33301H0.833008V4.49967H5.41634V1.74967C5.41634 1.50656 5.51292 1.2734 5.68483 1.10149C5.85673 0.929585 6.08989 0.833008 6.33301 0.833008H13.6663C13.9095 0.833008 14.1426 0.929585 14.3145 1.10149C14.4864 1.2734 14.583 1.50656 14.583 1.74967V4.49967ZM15.4997 6.33301H4.49967V17.333H15.4997V6.33301ZM7.24967 9.08301H9.08301V14.583H7.24967V9.08301ZM10.9163 9.08301H12.7497V14.583H10.9163V9.08301ZM7.24967 2.66634V4.49967H12.7497V2.66634H7.24967Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.3bdff3a073ec00ac784c075e4027aba1.svg";
export { ForwardRef as ReactComponent };